import { render, staticRenderFns } from "./DeliveryPlan.vue?vue&type=template&id=bc45c78a&"
import script from "./DeliveryPlan.vue?vue&type=script&lang=js&"
export * from "./DeliveryPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports